module.exports = __webpack_public_path__ + "static/brainmagic-d92017c0d2d8494758f0c5cadc9547ff.png";